<div class="relative w-full max-w-md">
  <span class="pi pi-search absolute start-3 top-1/2 -translate-y-1/2 text-sm text-gray-400"></span>
  <input
    pInputText
    class="w-full !ps-9"
    [placeholder]="'shared.globalSearch.placeholder' | translate"
    [ngModel]="query()"
    (ngModelChange)="onInput($event)"
    (focus)="open.set(query().trim().length >= 2)"
    [attr.aria-label]="'shared.globalSearch.ariaLabel' | translate"
  />

  @if (open()) {
    <div
      class="absolute z-50 mt-1 max-h-96 w-full overflow-y-auto rounded border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800"
    >
      @if (loading()) {
        <div class="p-3 text-sm text-gray-500">{{ 'shared.globalSearch.searching' | translate }}</div>
      } @else if (results().length === 0) {
        <div class="p-3 text-sm text-gray-500">{{ 'shared.globalSearch.noMatches' | translate }}</div>
      } @else {
        @for (result of results(); track result.kind + result.id) {
          <button
            type="button"
            class="flex w-full flex-col items-start gap-0.5 px-3 py-2 text-start text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
            (click)="select(result)"
          >
            <span class="font-medium">{{ result.label }}</span>
            <span class="text-xs text-gray-500">{{ result.kind }} · {{ result.sublabel }}</span>
          </button>
        }
      }
    </div>
  }
</div>
